<template>
  <dialog-form
      v-bind="$attrs"
      v-on="$listeners"
      :show="showPopup"
      @close="close()"
      :activator="false"
      :max-width="maxWidth"
      persistent
      :content-class="contentClass"
  >
    <div :data-attr="dataAttr">
      <h2 v-html="popupTitle"></h2>
      <div class="wrap">
        <div class="banner">
          <img src="@/assets/images/cat-headphone.svg" alt="Lorem" @load="onImgLoad">
        </div>
        <div class="loader">
          <v-progress-circular :size="160" width="10" color="primary" indeterminate/>
        </div>
      </div>
    </div>
  </dialog-form>
</template>

<script>
  import DialogForm from '@/shared/components/DialogForm/DialogForm.vue';

  export default {
    name: "PopupLoader",
    props: {
      maxWidth: { type: [String, Number], default: 740 },
      showPopup: { type: Boolean },
      dataAttr: { type: String, default: 'popup-loader' },
      title: { type: [String, Array] },
    },
    components: {
      DialogForm,
    },
    mounted() {
      this.incrementCounter();
    },
    computed: {
      contentClass() {
        return [!this.isLoaded ? 'isHidden' : '', 'loader-dialog'].join(' ');
      },
      popupTitle() {
        return Array.isArray(this.title) ? this.title[this.counter] : this.title;
      }
    },
    data: () => ({
      counter: 0,
      isLoaded: false,
    }),
    methods: {
      close() {
        this.$refs.form.reset();
        this.$emit('reset');
      },
      onImgLoad () {
        this.isLoaded = true;
      },
      incrementCounter() {
        const textLength = this.$t(`loaderText`).length;
        let currentIndex = 0;
        this.counter = currentIndex
        const intervalId = setInterval(() => {
          if (currentIndex < textLength - 1) {
            currentIndex += 1;
            this.counter = currentIndex;
          } else {
            clearInterval(intervalId);
          }
        }, 3000);
      }
    },
    watch: {
      showPopup(val) {
        if(!val) {
          this.isLoaded = false;
        }
      }
    }
  }
</script>

<style lang="scss">
  .isHidden {
    display: none;
    visibility: visible;
  }
  .loader-dialog {
    .dialog-content {
      padding: 41px 38px 17px;
      border: 10px solid $white;
      background: linear-gradient(44.69deg, #6BB7ED 0%, #6CCDF0 93.5%);

      @media (max-width: $tablet) {
        padding: 41px 20px 35px;
      }
    }

    h2 {
      text-align: center;
      font-size: 29px;
      margin-bottom: 44px;
      min-height: 70px;

      @media (max-width: $tablet) {
        font-size: 26px;
      }
    }

    .wrap {
      display: flex;
      justify-content: center;

      @media (max-width: $tablet) {
        align-items: center;
      }
    }

    .banner {
      width: 60%;
      padding-right: 34px;

      @media (max-width: $tablet) {
        width: 70%;
      }

      img {
        width: 100%;
        max-width: 250px;
        display: block;
      }
    }

    .loader {
      width: 40%;
      margin-top: 28px;
      overflow: hidden;

      @media (max-width: $tablet) {
        margin-top: 0;
        width: 30%;
      }
    }

    .v-progress-circular {
      color: $white !important;
      max-width: 100%;
    }
  }
</style>
